<template>
	<div>
		<Header></Header>
		<searchShop :mch="mch" :customer_service="customer_service"></searchShop>
		<!-- 广告 -->
		<div class="adv" v-if="false"></div>
		<navShop :mch="mch"></navShop>
		<div class="content">
			<div class="w d-flex justify-content-between">
				<div class="left">
					<div class="left-title">商品分类</div>
					<!-- <div class="left-list" v-for="(item, index) in cat_list" :key="index">
						<div class="list-top d-flex align-items-center">
							<div class="list-img">
								<img class="img-default" src="../../assets/images/shop_up.png" alt />
							</div>{{item.name}}
						</div>
						<div class="list-item d-flex align-items-center" v-for="(value, key) in item.list" :key="key">{{value.name}}</div>
					</div> -->
					<el-tree :data="cat_list" :props="{children: 'list',label: 'name'}" :highlight-current="true" accordion
					 @node-click="catChange"></el-tree>
				</div>
				<div class="right">
					<div class="filtrate d-flex justify-content-between">
						<div class="filtrate-l d-flex">
							<div class="filtrate-l-item d-flex align-items-center justify-content-center" @click="screenChange(0)" :class="{filtrate_active : 0 == sort}">综合</div>
							<div class="filtrate-l-item d-flex align-items-center justify-content-center" @click="screenChange(4)" :class="{filtrate_active : 4 == sort}">评论数</div>
							<div class="filtrate-l-item d-flex align-items-center justify-content-center" @click="screenChange(1)" :class="{filtrate_active : 1 == sort}">新品</div>
							<div class="filtrate-l-item d-flex align-items-center justify-content-center" @click="screenChange(3)" :class="{filtrate_active : 3 == sort}">销量</div>
							<div class="filtrate-l-item d-flex align-items-center justify-content-center" @click="screenChange(2)" :class="{filtrate_active : 2 == sort}">
								价格
								<div class="filtrate-l-img">
									<img class="img-default" src="../../assets/images/filtrate_pic.svg" alt v-if="sort != 2" />
									<div v-else>
										<img class="img-default" src="../../assets/images/filtrate_picnext.png" alt v-if="sort_type == 0" />
										<img class="img-default" src="../../assets/images/filtrate_picperv.png" alt v-if="sort_type == 1" />
									</div>
								</div>
							</div>
							<div class="filtrate-pic d-flex align-items-center">
								<div class="d-flex align-items-center filtrate-pics">
									<div class="filtrate-pic-input d-flex align-items-center">
										￥
										<input type="number" v-model="min_price" ref="min_price" />
									</div>
									<div class="line"></div>
									<div class="filtrate-pic-input d-flex align-items-center">
										￥
										<input type="number" v-model="max_price" ref="max_price" />
									</div>
								</div>
								<div class="clearfloat filtrate-picbut">
									<span @click="confirmPrice()">确定</span>
									<span @click="emptyPrice()">清空</span>
								</div>
							</div>
						</div>
						<div class="filtrate-r d-flex align-items-center">
							<template v-if="false">
								<div class="filtrate-r-item d-flex align-items-center">
									<div class="filtrate-r-img">
										<img class="img-default" src="../../assets/images/select_unchecked.png" alt />
									</div>自营商品
								</div>
								<div class="filtrate-r-item d-flex align-items-center">
									<div class="filtrate-r-img">
										<img class="img-default" src="../../assets/images/select_unchecked.png" alt />
									</div>有货商品
								</div>
							</template>
							<div class="filtrate-r-all" v-text="'共'+row_count+'个商品'"></div>
							<div class="filtrate-r-page d-flex align-items-center">
								<div class="page-img" :style="{'cursor': page<=1 ? 'no-drop' : 'pointer'}" @click="pagePerv()">
									<img class="img-default" src="../../assets/images/goods_left.png" alt />
								</div>
								<div class="page-num d-flex">
									<span v-text="page * limit > row_count ? row_count : page * limit"></span> / <p v-text="row_count"></p>
								</div>
								<div class="page-img" :style="{'cursor': page >= page_count ? 'no-drop' : 'pointer'}" @click="pageNext()">
									<img class="img-default" src="../../assets/images/goods_right.png" alt />
								</div>
							</div>
						</div>
					</div>
					<template v-if="list && list.length">
						<div class="ttshop_collection clearfloat d-flex flex-wrap">
							<template v-for="(item,index) in list">
								<div class="ttshop_collectionlist" @click="toGoods(item.id)">
									<div class="ttshop_collectionimg">
										<img class="img-default ttshop_collecimg" :src="item.pic_url || item.cover_pic" alt />
										<div class="ttshop_gmqx clearfloat" v-if="false">
											<button class="ttshop_join">
												<i>
													<img class="img-default" src="../../assets/images/ttshop_addshop.png" alt />
												</i>
												加入购物车
											</button>
											<button class="ttshop_removeshop">取消收藏</button>
										</div>
									</div>
									<div :class="['ttshop_collcon','ttshop_collcon'+index]" :style="{padding: item.pic_list.length<=6 ? '0 0': '0 18px'}">
										<div class="ttshop_collconter swiper-container">
											<ul class="clearfloat swiper-wrapper">
												<li class="swiper-slide" v-for="(itemSwiper,indexSwiper) in item.pic_list" :key="itemSwiper" @mouseenter="picEnter(itemSwiper,index)">
													<img class="img-default" :src="itemSwiper" alt />
												</li>
											</ul>
										</div>
										<!-- 左右箭头 -->
										<div class="swiper-button-prev ttshop_prev" @click.stop v-if="item.pic_list.length>6"></div>
										<div class="swiper-button-next ttshop_next" @click.stop v-if="item.pic_list.length>6"></div>
									</div>
									<div class="ttshop_collbut">
										<h5 v-text="'￥'+item.price"></h5>
										<p class="ttshop_shopname" v-text="item.name"></p>
										<div class="ttshop_colltext clearfloat">
											<div class="ttshop_colltextleft">
												<p><span v-text="item.comment_count > 0 ? item.comment_count : 0"></span>评价</p>
											</div>
											<div class="ttshop_colltextright" v-if="item.comment_count > 0">
												<p><span v-text="item.good_rate+'%'"></span>好评</p>
											</div>
										</div>
										<div class="clearfloat ttshop_collbutton" v-if="item.service && item.service.length">
											<p v-for="(itemService,indexService) in item.service" :key="indexService" v-text="itemService"></p>
										</div>
									</div>
								</div>
							</template>
						</div>
						<div class="right-paging d-flex align-items-center justify-content-end">
							<el-pagination background @current-change="pegeChange" :current-page.sync="page" :page-size="limit"
							 :hide-on-single-page='true' layout="prev, pager, next, total, jumper" :total="row_count"></el-pagination>
						</div>
					</template>
					<!-- 暂无商品时暂时 -->
					<template v-else>
						<div class="zanwugoods" v-if="data_type">
							<img class="img-default" src="../../assets/images/ttshop_zanwu.png" alt="">
							<p>暂无商品</p>
						</div>
					</template>
				</div>
			</div>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	import Header from "@/components/header/header";
	import Foot from "@/components/foot/foot";
	import searchShop from "@/components/search/searchShop";
	import navShop from "@/components/nav/navShop";
	import sidebar from "@/components/sidebar/sidebar";
	import {
		Swiper,
		SwiperSlide
	} from "vue-awesome-swiper";
	export default {
		components: {
			Header,
			Foot,
			searchShop,
			navShop,
		},
		data() {
			return {
				data_type: false,
				list: [],
				cat_list: [],
				mch: {}, //商户信息
				mch_id: this.$route.query.mch_id, //商户id
				cat_id: null, //分类id
				page_count: 0, //总页数
				row_count: 0, //总条数
				page: 1, //当前页数
				limit: 20, //每页条数
				sort: 0, //0=全部 1=最新 2=价格 3=销量 4=评价数量
				sort_type: '', //0=升序 1=倒序
				min_price: '',
				max_price: '',
				customer_service: ''
			};
		},
		created() {
			this.page = 1;
			this.getData();
			this.customerService();
			this.geyCatGoodsList();
		},
		methods: {
			// 获取店铺信息
			getData() {
				let params = {
					mch_id: this.mch_id
				};
				this.$api
					.shopIndex(params)
					.then((res) => {
						if (res.code == 0) {
							this.mch = res.data.mch_info;
						}
					})
					.catch((err) => {
						this.common.message(this, err);
					});
			},
			// 客服
			customerService(){
				let params = {
					mch_id: this.mch_id
				};
				this.$api.customerService(params).then((res) => {
					console.log(res)
					if (res.code == 0) {
						this.customer_service = res.customer_service;
					}
				}).catch((err) => {
					this.common.message(this, err);
				});
			},
			// 获取数据
			geyCatGoodsList() {
				this.$loading();
				this.data_type = false;
				let params = {
					mch_id: this.mch_id,
					cat_id: this.cat_id,
					page: this.page,
					limit: this.limit,
					sort: this.sort,
					min_price: this.min_price,
					max_price: this.max_price
				};
				if (this.sort == 2) {
					params.sort_type = this.sort_type;
				}
				this.$api
					.catGoodsList(params)
					.then((res) => {
						if (res.code == 0) {
							this.$loading().close();
							this.data_type = true;
							if (!this.cat_list.length) {
								this.cat_list = res.data.cat_list;
							}
							this.list = res.data.list;
							this.page_count = res.data.page_count;
							this.row_count = Number(res.data.row_count);
							setTimeout(() => {
								// 商品轮播
								for (let i = 0; i < res.data.list.length; i++) {
									let element = ".ttshop_collcon" + i + " .ttshop_collconter";
									let nextEl = ".ttshop_collcon" + i + " .ttshop_next";
									let prevEl = ".ttshop_collcon" + i + " .ttshop_prev";
									let mySwiper = new Swiper(element, {
										loop: false,
										slidesPerView: 5,
										spaceBetween: 6,
										observer: true,
										observeParents: true,
										navigation: {
											nextEl: nextEl,
											prevEl: prevEl,
										},
									});
								}
							}, 500)
						}
					})
					.catch((err) => {
						this.common.message(this, err)
					});
			},
			// 进入商品详情
			toGoods(id) {
				let url = this.$router.resolve({
					path: "/pages/goods/goods",
					query: {
						id: id
					}
				})
				window.open(url.href);
			},
			// 移入图片
			picEnter(url, index) {
				if (url) {
					this.list[index].pic_url = url;
				}
			},
			// 点击分类
			catChange(data) {
				if (this.cat_id == data.id) {
					return false
				}
				this.cat_id = data.id;
				this.page = 1;
				this.geyCatGoodsList();
			},
			// 筛选
			screenChange(sort) {
				if (this.sort == sort) {
					if (sort == 2) {
						this.sort_type == 0 ? this.sort_type = 1 : this.sort_type = 0
					} else {
						return false;
					}
				}
				this.sort = sort;
				this.page = 1;
				this.geyCatGoodsList();
			},
			// 价格最大值最小值筛选
			confirmPrice() {
				let min_price = Number(this.min_price);
				let max_price = Number(this.max_price);
				if (min_price > max_price) {
					this.min_price = max_price;
					this.max_price = min_price;
				}
				this.page = 1;
				this.geyCatGoodsList();
			},
			emptyPrice() {
				this.min_price = "";
				this.max_price = "";
				this.page = 1;
				this.geyCatGoodsList();
			},
			// 导航分页上一页
			pagePerv() {
				if (this.page > 1) {
					this.page--;
					this.common.backTop();
					this.geyCatGoodsList();
				}
			},
			// 导航分页下一页
			pageNext() {
				if (this.page < this.page_count) {
					this.page++;
					this.common.backTop();
					this.geyCatGoodsList();
				}
			},
			// 输入分页
			pegeChange(e) {
				this.page = e;
				this.common.backTop();
				this.geyCatGoodsList();
			},
		},
	};
</script>

<style lang="scss">
	.filtrate_active {
		border-bottom-color: #ff0e25 !important;
		color: #ff0e25 !important;
	}

	// 广告
	.adv {
		height: 120px;
		background: #cccccc;
	}

	.content {
		margin-top: 20px;
	}

	.left {
		width: 190px;
		min-width: 190px;
		border: 1px solid #ebebeb;
		background: #ffffff;
		height: 100%;

		// 修改分类默认样式
		.el-tree {
			>.el-tree-node {
				>.el-tree-node__content:first-child {
					background: #F2F2F2 !important;
					border-top: 1px solid #ebebeb;

					>.el-tree-node__label {
						color: #333 !important;
						font-weight: 600;
					}
				}
			}
		}

		// 选中状态
		.el-tree-node.is-current {
			>.el-tree-node__content:first-child {
				>.el-tree-node__label {
					color: #ff0e25 !important;
				}
			}
		}

		.el-tree-node__content {
			cursor: pointer;
			height: 32px;
			box-sizing: border-box;
			background: transparent !important;
		}

		.el-tree-node__content:hover {
			.el-tree-node__label {
				color: #ff0e25;
			}
		}

		.el-tree-node__label {
			font-size: 12px;
		}

		.left-title {
			height: 48px;
			padding: 12px;
			box-sizing: border-box;
			font-size: 16px;
			font-weight: 600;
		}

		.left-all {
			width: 190px;
			height: 32px;
			background: #f2f2f2;
			padding-left: 12px;
			box-sizing: border-box;
		}

		.left-all-item {
			height: 36px;

			span {
				color: #666666;
				margin-left: 12px;

				&:hover {
					color: #ff4300;
				}
			}
		}

		.left-list {
			.list-top {
				cursor: pointer;
				height: 32px;
				font-weight: 600;
				padding-left: 12px;
				border-top: 1px solid #ebebeb;
				border-bottom: 1px solid #ebebeb;
				background: #f2f2f2;
				box-sizing: border-box;

				.list-img {
					height: 12px;
					width: 12px;
					margin-right: 4px;
				}
			}

			.list-item {
				cursor: pointer;
				height: 32px;
				padding-left: 27px;
				box-sizing: border-box;
				color: #666666;

				&:hover {
					color: #ff4300;
				}
			}
		}
	}

	.right {

		// 暂无商品
		.zanwugoods {
			width: 100%;
			padding: 150px 0;
			box-sizing: border-box;

			img {
				display: block;
				width: 93px;
				height: 80px;
				margin: 0 auto 20px;
			}

			p {
				font-size: 16px;
				color: #333;
				text-align: center;
			}
		}

		.filtrate {
			width: 987px;
			height: 40px;
			background: #fafafa;

			.filtrate-l-item {
				min-width: 64px;
				padding: 0 8px;
				box-sizing: border-box;
				height: 40px;
				border-bottom: 2px solid transparent;
				color: #666666;
				cursor: pointer;

				.filtrate-l-img {
					height: 12px;
					width: 12px;
				}
			}

			.filtrate-pic {
				padding: 0 8px;
				position: relative;
				z-index: 1;

				.filtrate-pics {
					height: 40px;
				}

				.filtrate-picbut {
					display: none;
					position: absolute;
					background: #fff;
					width: 100%;
					top: 39px;
					left: 0;
					padding: 8px;
					box-sizing: border-box;
					box-shadow: 0 15px 12px rgba(0, 0, 0, .1);

					span {
						float: left;
						font-size: 12px;
						color: #666;
						border: 1px solid #EBEBEB;
						border-radius: 2px;
						width: 56px;
						height: 24px;
						box-sizing: border-box;
						text-align: center;
						line-height: 20px;
						cursor: pointer;
						transition: .5s;
						-moz-transition: .5s;
						-webkit-transition: .5s;
						-o-transition: .5s;

						&:first-child {
							border-color: #FF3346;
							background: #FFF0F1;
							color: #FF0E25;
							margin-right: 8px;
						}

						&:last-child:hover {
							border-color: #FF3346;
							background: #FFF0F1;
							color: #FF0E25;
						}
					}
				}

				.filtrate-pic-input {
					width: 64px;
					height: 24px;
					background: #ffffff;
					border-radius: 2px;
					border: 1px solid #ebebeb;
					color: #999999;

					input {
						height: 24px;
						width: 50px;
					}
				}

				.line {
					width: 10px;
					height: 2px;
					background: #cccccc;
					margin: 0 4px;
				}

				&:hover {
					background: #fff;
					box-shadow: 0 0 12px 0 rgba(0, 0, 0, .1);
					border-radius: 2px;
				}

				&:hover .filtrate-picbut {
					display: block;
					border-radius: 0 0 2px 2px;
				}
			}

			.filtrate-r-item {
				height: 40px;
				padding: 0 10px;
				box-sizing: border-box;
				color: #666666;
				cursor: pointer;

				.filtrate-r-img {
					height: 12px;
					width: 12px;
					margin-right: 4px;
				}
			}

			.filtrate-r-all {
				margin-left: 40px;
				color: #666666;
			}

			.filtrate-r-page {
				margin-right: 16px;
				margin-left: 8px;

				.page-num {
					font-weight: bold;
					color: #666666;
					margin: 0 4px;

					span {
						font-weight: bold;
						color: #ff0e25;
					}
				}

				.page-img {
					cursor: pointer;
					height: 14px;
					width: 14px;
				}
			}
		}

		.ttshop_collection {
			width: 100%;

			.ttshop_collectionlist {
				cursor: pointer;
				float: left;
				width: 246px;
				background: #fff;
				padding: 12px;
				box-sizing: border-box;
				margin-right: 2px;
				margin-bottom: 20px;
				transition: 0.5s;

				&:nth-child(4n) {
					margin-right: 0;
				}

				.ttshop_collectionimg {
					width: 100%;
					height: 222px;
					margin-bottom: 8px;
					position: relative;
					overflow: hidden;

					.ttshop_collecimg {
						display: block;
						width: 100%;
						height: 100%;
						object-fit: cover;
						margin: 0 auto;
					}

					.ttshop_gmqx {
						width: 100%;
						height: 28px;
						background: #ff0e25;
						position: absolute;
						bottom: 0;
						left: -100%;
						transition: 0.5s;
						-moz-transition: 0.5s;
						-webkit-transition: 0.5s;
						-o-transition: 0.5s;

						.ttshop_join {
							float: left;
							width: 148px;
							height: 28px;
							border: 0;
							outline: none;
							font-size: 12px;
							color: #fff;
							background: #ff0e25;
							cursor: pointer;

							i {
								display: inline-block;
								width: 16px;
								height: 16px;
								vertical-align: -3px;

								img {
									display: block;
									width: 100%;
								}
							}
						}

						.ttshop_removeshop {
							width: 73px;
							height: 26px;
							margin-top: 1px;
							margin-right: 1px;
							font-size: 12px;
							color: #ff0e25;
							border: 0;
							outline: none;
							cursor: pointer;
							background: #fff;
						}
					}

					&:hover .ttshop_gmqx {
						left: 0;
					}
				}

				.ttshop_collcon {
					width: 100%;
					padding: 0 21px;
					box-sizing: border-box;
					position: relative;
					margin-bottom: 12px;

					.ttshop_collconter {
						width: 100%;

						ul {
							li {
								float: left;
								width: 32px !important;
								height: 32px;
								border: 1px solid #ebebeb;
								padding: 1px;
								box-sizing: border-box;
								transition: 0.5s;
								-moz-transition: 0.5s;
								-webkit-transition: 0.5s;
								-o-transition: 0.5s;

								&:hover {
									border-color: #ff0e25;
								}

								img {
									display: block;
									width: 28px;
									height: 28px;
									margin: 0 auto;
									object-fit: cover;
								}
							}
						}
					}

					.ttshop_prev {
						width: 14px;
						height: 14px;
						margin-top: -7px;
						background: url(../../assets/images/ttshop_scleft.png) center no-repeat;
						left: 0;
						cursor: pointer;
						z-index: 100;
						outline: none;
					}

					.ttshop_next {
						width: 14px;
						height: 14px;
						margin-top: -7px;
						background: url(../../assets/images/ttshop_scright.png) center no-repeat;
						right: 0;
						cursor: pointer;
						z-index: 100;
						outline: none;
					}
				}

				.ttshop_collbut {
					width: 100%;

					h5 {
						font-size: 20px;
						color: #ff4300;
						font-weight: bold;
						line-height: 20px;
						margin-bottom: 7px;
					}

					.ttshop_shopname {
						width: 100%;
						font-size: 12px;
						color: #666;
						font-weight: 400;
						line-height: 18px;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
						overflow: hidden;
						max-height: 36px;
						height: 36px;
						margin-bottom: 8px;
						transition: 0.5s;
						-moz-transition: 0.5s;
						-webkit-transition: 0.5s;
						-o-transition: 0.5s;
					}

					.ttshop_colltext {
						width: 100%;
						margin-bottom: 12px;

						.ttshop_colltextleft {
							float: left;

							p {
								font-size: 12px;
								color: #999;
								line-height: 12px;

								span {
									font-size: 12px;
									color: #0e9cff;
									margin-right: 4px;
								}
							}
						}

						.ttshop_colltextright {
							float: right;

							p {
								font-size: 12px;
								color: #999;
								line-height: 12px;

								span {
									margin-right: 4px;
									font-size: 12px;
									color: #ff9010;
								}
							}
						}
					}

					.ttshop_collbutton {
						width: 100%;

						p {
							float: left;
							font-size: 12px;
							color: #ff0e25;
							border: 1px solid #ff0e25;
							border-radius: 3px;
							font-weight: 400;
							line-height: 12px;
							padding: 2px 4px;
							box-sizing: border-box;
							margin: 0 4px 4px 0;
						}

						p:last-child {
							margin-right: 0;
						}
					}
				}
			}

			.ttshop_collectionlist:hover {
				.ttshop_shopname {
					color: #ff0e25;
				}
			}
		}

		.right-paging {
			margin: 40px 0;
		}
	}
</style>
